// on scroll in mobile to hide search bar
// if (window.innerWidth < 640) {
// 	$("#shopify-section-header_new").css("background", "transparent");
// 	$(".main_nav_wrapper-inner").css("height", "65px");
// }

// // let lastScrollPosition = 0;

// window.addEventListener("scroll", function () {
// 	const scrollPosition = this.document.querySelector("#shopify-section-header_new") || this.scrollY;
// 	// console.log("scrolling....", scrollPosition.offsetTop);

// 	if (this.innerWidth < 640) {
// 		if (scrollPosition.offsetTop > 200) {
// 			$(".main_nav").css("display", "none");
// 			$(".new_header_fine").css("background", "transparent").css("visibility", "hidden");
// 		} else {
// 			$(".main_nav").css("display", "block");
// 			$(".new_header_fine").css("background", "white").css("visibility", "visible");
// 			// $("#shopify-section-header_new").css("background", "white");
// 		}
// 	}

// 	// lastScrollPosition = scrollPosition.offsetTop <= 0 ? 0 : scrollPosition.offsetTop;
// });

// splide init
document.addEventListener("DOMContentLoaded", function () {
	let main = new Splide("#main-carousel", {
		type: "fade",
		fixedWidth: "100%",
		// fixedHeight: 480,
		pagination: false,
		arrows: arrowIsTrue,
		// cover: true,
		breakpoints: {
			768: {
				fixedHeight: 390,
			},
			1024: {
				fixedHeight: 360,
			},
		},
	});
	let thumbnails = new Splide("#thumbnail-carousel", {
		rewind: true,
		fixedWidth: 80,
		fixedHeight: 80,
		isNavigation: true,
		gap: 10,
		focus: "center",
		pagination: false,
		arrows: false,
		cover: true,
		dragMinThreshold: {
			mouse: 4,
			touch: 10,
		},
		// breakpoints: {
		// 	640: {
		// 		fixedWidth: 77,
		// 		fixedHeight: 79,
		// 	},
		// },
	});

	main.sync(thumbnails);
	main.mount();
	thumbnails.mount();
});

// read more and less
class ReadMoreLess {
	constructor(el) {
		this.el = el;
		this.buttonText = el.querySelector("button span");
		this.descriptionEl = el.querySelector(".description-control");
		this.open = false;
	}

	onClick(e) {
		e.preventDefault();
		if (this.open) {
			this.open = false;
			this.buttonText.textContent = "show more";
		} else {
			this.open = true;
			this.buttonText.textContent = "show less";
		}

		if (this.open) this.expand();
		else this.shrink();
	}

	expand() {
		this.descriptionEl.classList.remove("new-product-description");
	}

	shrink() {
		this.descriptionEl.classList.add("new-product-description");
	}
}

const readMoreLessElement = new ReadMoreLess(
	document.querySelector("div.description-with-button-container")
);

const showMoreButton = document.querySelector("div.description-with-button-container button");
if($("div.description-with-button-container button").length){
showMoreButton.addEventListener("click", function (e) {
	readMoreLessElement.onClick(e);
});
}
// scrollable and dragable slider - mainly for addon filter
// https://codepen.io/thenutz/pen/VwYeYEE
const slider = document.querySelector(".addon-filter-slider");
let isDown = false;
let startX;
let scrollLeft;

if($(slider).length){
	slider.addEventListener("mousedown", (e) => {
		isDown = true;
		slider.classList.add("active");
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	});
	slider.addEventListener("mouseleave", () => {
		isDown = false;
		slider.classList.remove("active");
	});
	slider.addEventListener("mouseup", () => {
		isDown = false;
		slider.classList.remove("active");
	});
	slider.addEventListener("mousemove", (e) => {
		if (!isDown) return;
		e.preventDefault();
		const x = e.pageX - slider.offsetLeft;
		const walk = (x - startX) * 3; //scroll-fast
		slider.scrollLeft = scrollLeft - walk;
		// console.log(walk);
	});
}

// update price by variant
// switch to image based on variant
/**
 * this can be done by getting the featured media id from <option>
 * and media.id from thumbnail carousel
 * input -> option[data-media-id] -> li[data-media-id]
 */
class VariantSelect {
	constructor(el) {
		this.el = el;
		this.el.addEventListener("change", (e) => this.onVariantChange(e));
	}

	onVariantChange(e) {
		const selectedOption = this.el.querySelector("option:checked");
		const newPrice = selectedOption.getAttribute("data-price");
		
		const featuredImageId = selectedOption.getAttribute("data-media-id");
                const compareAtPrice = selectedOption.getAttribute("data-compare-at-price"); // Get compare-at price
		
		if (newPrice) this.updatePrice(newPrice,compareAtPrice);
		if (featuredImageId) this.updateFeaturedImage(featuredImageId);
	}

	updatePrice(price,compareAtPrice) {
		// get price from option and replace the price in span.current_price
		const moneyContainer = document.querySelector(
			".price-with-atome-style .modal_price .current_price"
		);
		// const mobileMoneyContainer = document.querySelector(".mobile-total-price-entry .money");
		moneyContainer.innerHTML = price;
		// mobileMoneyContainer.innerHTML = price;
		 // Update the compare-at price, if available
    if (compareAtPrice) {
        const compareAtMoneyContainer = document.querySelector(
            ".price-with-atome-style .modal_price .money"
        );
        compareAtMoneyContainer.innerHTML = compareAtPrice;
    }

		updateTotalPrice();
	}

	updateFeaturedImage(imageId) {
		// click featured image from carousel
		const carouselThumbnailElement = document.querySelector(
			`#thumbnail-carousel li[data-media-id="product-template-v2-${imageId}"]`
		);
		if (carouselThumbnailElement) $(carouselThumbnailElement).trigger("click");
	}
}

const variantSelectTag = document.querySelector("div.select select");
const variantRadioButtons = document.querySelectorAll(
	".variant-option-picker-container input[type='radio']"
);

let variantSelectFunction
if (variantSelectTag) {
	variantSelectFunction = new VariantSelect(variantSelectTag);
}

if (variantRadioButtons) {
	variantRadioButtons.forEach((el) => {
		el.addEventListener("change", function () {
			let variant = "";
			const allCheckedVariant = document.querySelectorAll(
				".variant-option-picker-container input[type='radio']:checked"
			);

			allCheckedVariant.forEach((el, index) => {
				if (index) variant = variant + " / " + el.value;
				else variant += el.value;
			});

			// change value for <select> and trigger change event
			// https://stackoverflow.com/questions/43289551/selecting-an-option-based-on-the-value-of-its-data-attribute
			$(`div.select select option[data-variant-name="${variant}"]`).prop("selected", true);
			variantSelectTag.dispatchEvent(new Event("change"));
		});
	});
}

// setup variant availability and unavailability
// get array of options from each select -> option
// check if each option has disabled attribute
document.addEventListener("DOMContentLoaded", function () {
	if (variantSelectTag) {
		const allOptions = variantSelectTag.querySelectorAll("option");
		const optionAvailability = [];

		allOptions.forEach((option) => {
			optionAvailability.push({
				option1: option.getAttribute("data-option1"),
				option2: option.getAttribute("data-option2"),
				option3: option.getAttribute("data-option3"),
				disabled: option.disabled,
			});
		});

		// console.log("options availability: ", optionAvailability);
	}
});

// quantity update
$("body").on("click", ".quantity-input-control span", function () {
	console.log("click");
	const minQuantity = 1;
	let maxQuantityAllowed = 10000;
	const quantityAction = $(this).data("func");
	const quantityInput = document.querySelector("input#quantity");
	const currentQuantity = Number(quantityInput.value);

	if (quantityInput.getAttribute("max") !== null)
		maxQuantityAllowed = quantityInput.getAttribute("max");

	if (isNaN(currentQuantity) || currentQuantity < minQuantity) {
		quantityInput.value = minQuantity;
		return;
	} else if (currentQuantity > maxQuantityAllowed) {
		quantityInput.value = maxQuantityAllowed;
		return;
	}

	if (quantityAction == "plus") {
		if (currentQuantity < maxQuantityAllowed) quantityInput.value = currentQuantity + 1;
	} else {
		if (currentQuantity > minQuantity) quantityInput.value = currentQuantity - 1;
	}

	quantityInput.dispatchEvent(new Event("change"));
});

// add item to cart and redirect to cart page
// - if there is select tag, take variant id from there
// - if there is no options, take hidden input value with name="id"
// - need to take in account for selected addon
$("button.product_add_to_cart").on("click", function () {
	$(this).prop("disabled", true);
	var objATC = $(this);
	objATC.find("span").text("Adding...");

	const items = [];
	const productId = !variantSelectTag
		? document.querySelector("input[name='id']").value
		: variantSelectTag.value;
	let productQuantity = document.querySelector("input#quantity").value;
	const addonProducts = document.querySelectorAll(".add-ons-wrap .selected");

	if (window.innerWidth <= 768) {
		productQuantity = document.querySelector("input#mobile_quantity").value;
	}

	// console.log("prduct id: ", productId);
	// console.log("product quantity: ", productQuantity);
	// console.log("addon product list: ", addonProducts);

	// construct request object
	/*
	items.push({
		quantity: productQuantity,
		id: productId,
	});
	*/
	addonProducts.forEach((addon) => {
		const addonId = addon.getAttribute("data-vid");
		items.push({
			quantity: 1,
			id: addonId,
		});
	});

	// console.log(items);

	// upon success, redirect user to cart page
	if(items.length){  // IF Addons selected
		$.ajax({
			type: "POST",
			url: "/cart/add.js",
			dataType: "json",
			data: {
				items: items,
			},
			success: function (sucess) {
				// window.location.href = "/cart";
				objATC.find("span").text("Add To Cart");
				$("form.shopify-product-form").submit();
			},
			error: function (error) {
				console.error(error);
				$(this).prop("disabled", false);
				objATC.find("span").text("Add To Cart");
			},
		});
	}else{
		$("form.shopify-product-form").submit();
		objATC.find("span").text("Add To Cart");
	}

	$(this).prop("disabled", false);
});

$("input#mobile_quantity").on("change", function () {
	console.log("mobile input change....");
	updateTotalPrice();
});

const hideMobileKeyboardOnReturn = (element) => {
    element.addEventListener('keyup', (keyboardEvent) => {
        const key = keyboardEvent.code || keyboardEvent.keyCode;
        if (key === 'Enter' || key === 13) {
            element.blur();
        }
    });
};

hideMobileKeyboardOnReturn(document.querySelector("input#mobile_quantity"))

if (variantSelectTag) {
	setTimeout(function() {
		variantSelectFunction.onVariantChange();
	}, 500)
}

// if there is teeinblue app present, remove mobile sticky checkout
const teeInBlue = document.querySelector(".tee-in-blue-product")
console.log(teeInBlue);
if (teeInBlue) {
	// remove mobile sticky if is teeinblue product
	document.querySelector(".mobile-sticky-add-to-cart-button").remove()
}
